<template>
    <v-dialog v-model="dialog.show" persistent max-width="700px">
        <v-card class="ui-card">
            <div class="ui-card__header">
                <div>
                    <h3 class="ui-section-title">Adicionar Informações</h3>
                    <p class="ui-section-description">Texto livre exibido junto à assembleia (até 2000 caracteres).</p>
                </div>
            </div>
            <div class="ui-card__body">
                <div class="editor-container">
                    <tiptap-vuetify class="custom-editor" v-model="dataset.assemblyCommentText"
                        :extensions="extensions" placeholder="Digite aqui informações adicionais da assembleia..." hide-details="auto" />
                </div>
            </div>
            <div class="ui-card__footer">
                <v-btn text @click.native="goBack">Cancelar</v-btn>
                <v-btn v-if="$allowed('save')" @click="saveCommentData" color="primary" depressed>Salvar</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import 'moment/locale/pt-br';

import { eventHub } from "@/main";

import axios from "axios"

import string from "@/common/util/string"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, 
    Blockquote, HardBreak, HorizontalRule, History, Table, TableCell, TableHeader, TableRow, TodoList, TodoItem
} from 'tiptap-vuetify'

export default {

    data: () => ({
        dataset: {
            data: {},
            loading: false,
            assemblyCommentText: null,
        },

        dialog: {
            show: false,
            resolve: null,
            reject: null,
        },

        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [1, 2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            [Table, {
                options: {
                    resizable: true
                }
            }],
            TableCell,
            TableHeader,
            TableRow,
        ],
    }),

    components: { 'tiptap-vuetify': TiptapVuetify },

    methods: {

        open() {
            this.dialog.show = true;
                        
            this.dataset.assemblyCommentText = this.dataset.data.comments

            return new Promise((resolve, reject) => {
                this.dialog.resolve = resolve;
                this.dialog.reject = reject;
            });
            
        },

        close() {
            this.dialog.resolve()
            this.dialog.show = false;
        },

        goBack() {
            this.dataset.data = {};
            this.close();
        },

        setData(item) {
            this.dataset.data = item
        },


        async saveCommentData() {
       
            if (this.dataset.assemblyCommentText.length > 2000) {
                this.$dialog.notify.error("O texto excedeu o limite de 2000 caracteres", { position: "top-right", timeout: 5000 });
                return; 
            }
           
            const id = this.dataset.data.id

            try {

                const response = await axios.patch(`/api/admin/general-meetings/${id}`, {comments: this.dataset.assemblyCommentText}, {
                    
                })

                this.$dialog.notify.info("Informações adicionadas com sucesso!", { position: "top-right", timeout: 3000 });

                this.goBack()

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } 

        },
        
    }
};
</script>

<style lang="scss">

.title-page {
    color: var(--v-primary-base);
    font-family: "Raleway";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

p {
    text-align: justify;
}

.editor-container {
  height: 500px; 
  overflow-y: auto; 
}

.custom-editor {
    .tiptap-vuetify-editor__content {
        min-height: 300px !important;
    }
        
    .ProseMirror {
        min-height: 300px !important;
    }
}


</style>
